import { type DocumentPickerAsset, type DocumentPickerOptions, getDocumentAsync } from "expo-document-picker";
import type { ReactNode } from "react";
import { useState } from "react";
import { YStack } from "tamagui";
import type { YStackProps } from "./Stacks";
type Props = Omit<YStackProps, "children"> & {
  onFilesSelected: (files: DocumentPickerAsset[], setButtonLoading: (loading: boolean) => void) => void;
  children: (isLoading: boolean) => ReactNode;
  accept?: DocumentPickerOptions["type"];
  multiple?: boolean;
};
export const FilePickerButton = ({
  onFilesSelected,
  children,
  accept = ["application/pdf", "image/jpeg", "image/png", "image/jpg"],
  multiple = true,
  ...rest
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const pickDocumentAsync = async () => {
    setIsLoading(true);
    try {
      // This library will launch the model slower than expected and close the
      // modal before the promise resolves. We pass the button loading function
      // so it fires at the same time the drawer closes
      const result = await getDocumentAsync({
        type: accept,
        multiple
      });
      if (!result.canceled) {
        onFilesSelected(result.assets, setIsLoading);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error picking document", error);
    }
  };
  return <YStack theme="granted" disabled={isLoading} jc="flex-start" w="100%" p="$4" cursor="pointer" onPress={pickDocumentAsync} {...rest} data-sentry-element="YStack" data-sentry-component="FilePickerButton" data-sentry-source-file="FilePickerButton.tsx">
      {children?.(isLoading)}
    </YStack>;
};